import { loadAssignmentDetailsForExperimentEpicReducer, loadAssignmentDetailsForFeatureEpicReducer } from "./epics.js";
const assignmentDetailsDefaultReducerState = {
  experiments: {},
  features: {}
};
const assignmentDetailsReducer = (state = assignmentDetailsDefaultReducerState, action) => {
  state = loadAssignmentDetailsForExperimentEpicReducer.reduxChange(state, action);
  state = loadAssignmentDetailsForFeatureEpicReducer.reduxChange(state, action);
  return state;
};
const assignmentDetailsModuleReducer = {
  assignment_details_data: assignmentDetailsReducer
};
export {
  assignmentDetailsDefaultReducerState,
  assignmentDetailsModuleReducer
};
//# sourceMappingURL=reducers.js.map
